import React from "react";
import Text from "@/components/ui/text";
import { ContractRevenueItem } from "@/pages/contracts/types";
import { useTranslation } from "react-i18next";
import RevenueItemsTable from "@/pages/deals/components/commercials/DealCommercialsV2/ContractTermsV2/components/RevenueItemsTable";

interface Props {
  revenueItems: ContractRevenueItem[];
  productId?: string;
  contractId?: string;
  currency?: string;
}

const ServicesSection: React.FC<Props> = ({
  revenueItems,
  productId,
  contractId,
  currency = "USD"
}) => {
  const { t } = useTranslation();

  if (revenueItems.length === 0) {
    return (
      <div className="flex flex-col">
        <Text variant="label" className="px-5 py-4">
          {t("companies.commercials.services")}
        </Text>
        <div className="py-8 text-center">
          <Text variant="bodySecondary">
            {t("companies.commercials.noServices")}
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <Text variant="label" className="px-5 py-4">
        {t("companies.commercials.services")}
      </Text>
      <RevenueItemsTable
        revenueItems={revenueItems}
        productId={productId}
        contractId={contractId}
        currency={currency}
        showAddService={false}
      />
    </div>
  );
};

export default ServicesSection;
